/* eslint-disable no-barrel-files/no-barrel-files */
/**
 * @generated
 * This file re-exports types from the Relay-generated artifact
 * This file provides type aliases for the Relay-generated artifact
 * to maintain backward compatibility with existing imports.
 *
 * All types are generated by Relay compiler from GraphQL operations.
 */

export type {
	SpaceRoleAssignmentsByCriteriaQuery$data as SpaceRoleAssignmentsByCriteriaQuery,
	SpaceRoleAssignmentsByCriteriaQuery$variables as SpaceRoleAssignmentsByCriteriaQueryVariables,
} from '../__generated__/SpaceRoleAssignmentsByCriteriaQuery.graphql.ts';

// Nested types extracted from Relay-generated types
import type { SpaceRoleAssignmentsByCriteriaQuery$data } from '../__generated__/SpaceRoleAssignmentsByCriteriaQuery.graphql.ts';
export type SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_principal = NonNullable<NonNullable<NonNullable<NonNullable<SpaceRoleAssignmentsByCriteriaQuery$data['spaceRoleAssignmentsByCriteria']>['nodes']>[number]>['principal']>;
export type SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_role_spacePermissionList = NonNullable<NonNullable<NonNullable<NonNullable<SpaceRoleAssignmentsByCriteriaQuery$data['spaceRoleAssignmentsByCriteria']>['nodes']>[number]>['role']>['spacePermissionList'][number];
export type SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_role = NonNullable<NonNullable<NonNullable<NonNullable<SpaceRoleAssignmentsByCriteriaQuery$data['spaceRoleAssignmentsByCriteria']>['nodes']>[number]>['role']>;
export type SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_permissions = NonNullable<NonNullable<NonNullable<NonNullable<SpaceRoleAssignmentsByCriteriaQuery$data['spaceRoleAssignmentsByCriteria']>['nodes']>[number]>['permissions']>[number];
export type SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes_array = NonNullable<NonNullable<NonNullable<NonNullable<SpaceRoleAssignmentsByCriteriaQuery$data['spaceRoleAssignmentsByCriteria']>>>>['nodes'];
export type SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_nodes = NonNullable<NonNullable<NonNullable<SpaceRoleAssignmentsByCriteriaQuery$data['spaceRoleAssignmentsByCriteria']>['nodes']>[number]>;
export type SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria_pageInfo = NonNullable<NonNullable<SpaceRoleAssignmentsByCriteriaQuery$data['spaceRoleAssignmentsByCriteria']>['pageInfo']>;
export type SpaceRoleAssignmentsByCriteriaQuery_spaceRoleAssignmentsByCriteria = NonNullable<SpaceRoleAssignmentsByCriteriaQuery$data['spaceRoleAssignmentsByCriteria']>;

// GraphQL enums (preserved from original file)
// ⚠️  DEPRECATION WARNING: Prefer using Relay's generated union string types instead of enums.
// Relay generates more type-safe union types (e.g., "DRAFT" | "PUBLISHED" | "ARCHIVED")
// instead of enums. These enums are kept for backward compatibility only.
export enum ConfluenceGroupManagementType {
  ADMINS = "ADMINS",
  EXTERNAL = "EXTERNAL",
  OPEN = "OPEN",
  TEAM_MEMBERS = "TEAM_MEMBERS",
}

export enum ConfluenceGroupUsageType {
  ADMIN_OVERSIGHT = "ADMIN_OVERSIGHT",
  TEAM_COLLABORATION = "TEAM_COLLABORATION",
  USERBASE_GROUP = "USERBASE_GROUP",
}

export enum PrincipalFilterType {
  APP = "APP",
  GROUP = "GROUP",
  GUEST = "GUEST",
  USER = "USER",
  USER_CLASS = "USER_CLASS",
}

export enum SpaceRoleType {
  CUSTOM = "CUSTOM",
  SYSTEM = "SYSTEM",
}

